const PulseLoader = ({isFull = false}) => {
    return (
        <div className={`flex justify-center items-center h-screen w-screen z-[100] ${isFull ? "fixed top-0 left-0 bg-[#0000001f]" :""}`}>
            <div className="space-x-2 flex">
                <div className="h-4 w-4 bg-magenta rounded-full animate-pulse"></div>
                <div className="h-4 w-4 bg-magenta rounded-full animate-pulse delay-150"></div>
                <div className="h-4 w-4 bg-magenta rounded-full animate-pulse delay-300"></div>
            </div>
        </div>
    );
};

export default PulseLoader;
